export { request } from './Api';

/*
 * Generate a globally unique identifier
 */
export function guid() {
  function s4() {
    return Math.floor((1 + Math.random()) * 0x10000)
      .toString(16)
      .substring(1);
  }
  return s4() + s4() + '-' + s4() + '-' + s4() + '-' +
    s4() + '-' + s4() + s4() + s4();
}

export function mapStateToProps(state) {
  return state;
}

export function mapDispatchToProps(dispatch) {
  return {
    dispatch
  };
}

/*
 * Intersection 2 arrays
 *
 * Credit: https://stackoverflow.com/questions/16227197/compute-intersection-of-two-arrays-in-javascript
 */
 export function intersection(a, b) {
     var t;
     if (b.length > a.length) t = b, b = a, a = t; // indexOf to loop over shorter
     return a.filter(function (e) {
         return b.indexOf(e) > -1;
     });
 }

export function addToCache(existingData, data) {
  if(data.data) {
    data = data.data;
  }

  // Ensure data is valid
  if(data.length) {
    let newPostsState = existingData;
    // Add or replace posts
    data.forEach((obj) => {
      // Replace existing
      let replaceExisting = false;

      newPostsState.forEach((el, i) => {
        if(el.id === obj.id) {
          newPostsState[i] = obj;
          replaceExisting = true;
          return;
        }
      });

      if(replaceExisting) return;

      // Push to posts
      newPostsState = newPostsState.concat(obj);
    });

    return newPostsState;
  }

  // Data is not in expected format, return the existing state
  return existingData;
}



// WEBPACK FOOTER //
// ./src/utils/index.js